// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  ListItemText,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import "./qoute.css";
import { useEffect, useState } from "react";
import products from "static-data/products";
import { useDispatch, useSelector } from "react-redux";
import { GetQuoteAPI, APIQuestionnaireProd } from "api-services";
import { useLocation } from "react-router-dom";
import { useMaterialUIController } from "context";
import { ShowSuccessMessage } from "helpers";
import MDTypography from "components/MDTypography";
import { CheckBox } from "@mui/icons-material";

const assetClassNames = ["Equity", "Options", "Complex"];

function GetQuote() {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [productId, setProductId] = useState("");
  const [text, setText] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const loading = useSelector((state) => state.products.loading);
  const userData = useSelector((state) => state.authentication.user_data);

  // Questionnaire Form
  const [liveDate, setLiveDate] = useState("");
  const [clearingDone, setClearingDone] = useState("");
  const [assetClasses, setAssetClasses] = useState([]);
  const [msgPerDay, setMsgPerDay] = useState("");
  const [msgPerDayNotNeg, setMsgPerDayNotNeg] = useState("");
  const [latencyReq, setLatencyReq] = useState("");
  const [businessRoute, setBusinessRoute] = useState("");
  const [serversHost, setServersHost] = useState("");
  const [msgPerSecPeak, setMsgPerSecPeak] = useState("");
  const [msgPerSecPeakNotNeg, setMsgPerSecPeakNotNeg] = useState("");
  const [systemProspect, setSystemProspect] = useState("");
  const [succession, setSuccession] = useState(false);
  const [riskcheck, setRiskcheck] = useState("");

  const [apiID, setApiID] = useState("");
  const [required, setRequired] = useState("");

  // Validation Questionnaire
  const handleValidationQuestionnaire = () => {
    let tempErrors = {};
    let isValid = true;

    if (liveDate.length <= 0) {
      tempErrors["liveDate"] = true;
      isValid = false;
    }

    if (clearingDone.length <= 0) {
      tempErrors["clearingDone"] = true;
      isValid = false;
    }

    if (assetClasses.length <= 0) {
      tempErrors["assetClasses"] = true;
      isValid = false;
    }

    if (Math.sign(msgPerDay) === 0) {
      tempErrors["msgPerDay"] = true;
      isValid = false;
    }

    if (Math.sign(msgPerDayNotNeg) === -1) {
      tempErrors["msgPerDayNotNeg"] = true;
      isValid = false;
    }

    if (msgPerSecPeak.length === 0) {
      tempErrors["msgPerSecPeak"] = true;
      isValid = false;
    }

    if (Math.sign(msgPerSecPeakNotNeg) === -1) {
      tempErrors["msgPerSecPeakNotNeg"] = true;
      isValid = false;
    }

    if (latencyReq.length <= 0) {
      tempErrors["latencyReq"] = true;
      isValid = false;
    }

    if (businessRoute.length <= 0) {
      tempErrors["businessRoute"] = true;
      isValid = false;
    }

    if (serversHost.length <= 0) {
      tempErrors["serversHost"] = true;
      isValid = false;
    }

    if (systemProspect.length <= 0) {
      tempErrors["systemProspect"] = true;
      isValid = false;
    }

    if (!succession) {
      tempErrors["succession"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };

  const dispatchData = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    let productID = params.get("key");
    if (productID) {
      setProductId(productID);
    }
  }, []);

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (text?.length <= 0) {
      tempErrors["text"] = true;
      isValid = false;
    }

    if (productId?.length <= 0) {
      tempErrors["product"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };

  // API Request
  const handleSubmit = (text) => {
    const apinames = products.filter((item) => item.key == productId)[0]?.name;
    let data = {
      apiID: productId,
      remarks: text,
      customerID: userData?.customer?.id,
      userEmail: userData?.customer?.email,
      apiName: apinames,
      companyName: userData?.customer?.companyName,
    };

    if (productId == 3) {
      if (handleValidationQuestionnaire()) {
        handleSubmitQues();
        GetQuoteAPI(
          dispatchData,
          data,
          success,
          setShowErrorMessage,
          clearFields
        );
      }
    } else if (productId != 3) {
      if (handleValidation()) {
        GetQuoteAPI(
          dispatchData,
          data,
          success,
          setShowErrorMessage,
          clearFields
        );
      }
    }
  };

  // Questionnaire  Form Submit
  const handleSubmitQues = () => {
    const getVal = succession === true;
    const getAssetClasses = assetClasses;
    const newAssetClasses = getAssetClasses.join();
    let data = {
      id: "0",
      userName: userData?.customer?.email,
      apiIdentifier: "0",
      clientName: userData?.customer?.fullName,
      dateofLive: liveDate,
      clearingArea: clearingDone,
      assetClassesName: newAssetClasses,
      msgsPerDayCount: msgPerDay,
      msgsPerSecond: msgPerSecPeak,
      businessRouting: businessRoute,
      serversHosting: serversHost,
      latencyRequirement: latencyReq,
      systemType: systemProspect,
      riskCheck: getVal,
      alternative: riskcheck,
    };

    APIQuestionnaireProd(dispatchData, data, setShowErrorMessage, clearFields);
  };

  const success = () => {
    ShowSuccessMessage(
      dispatch,
      "Request Submitted",
      "Your request for access to Production API has been submitted."
    );
  };

  const clearFields = () => {
    setText("");
    setProductId(null);
    setLiveDate("");
    setClearingDone("");
    setAssetClasses([]);
    setMsgPerDay("");
    setMsgPerDayNotNeg("");
    setLatencyReq("");
    setBusinessRoute("");
    setServersHost("");
    setMsgPerSecPeak("");
    setMsgPerSecPeakNotNeg("");
    setSystemProspect("");
    setSuccession("");
    setRiskcheck("");
    setShowErrorMessage("");
  };

  // Multi Selectbox
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setAssetClasses(typeof value === "string" ? value.split(",") : value);
  };

  const renderContent = () => {
    if (required == "Required" && apiID == 3) {
      return (
        <>
          <Grid item xs={12} lg={4}>
            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              What is target to Go Live date?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="date"
              className="form-control "
              id="livedate"
              name="fullname"
              placeholder="Full Name*"
              value={liveDate}
              onChange={(e) => {
                setLiveDate(e.target.value);
              }}
            />
            {errors?.liveDate && (
              <p className="text-red">Please select Go Live Date</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Which Asset Classes will be sent?
              <span className="color-red">*</span>
            </MDTypography>
            <FormControl sx={{ m: 1, width: "100%", margin: "0px!important" }}>
              <InputLabel id="demo-multiple-checkbox-label">
                Select Options
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                className="custom-selectbox"
                value={assetClasses}
                onChange={handleChange}
                input={<OutlinedInput label="Select Options" />}
                renderValue={(selected) => selected.join(", ")}
                sx={{
                  height: "44px",
                  padding: "8px",
                  marginLeft: "0px!important",
                  marginRight: "0px!important",
                }}
              >
                {assetClassNames.map((name) => (
                  <MenuItem key={name} value={name} className="cstm-menuitem">
                    <CheckBox checked={assetClasses.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errors?.assetClasses && (
              <p className="text-red">This field cannot be empty</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Are there any latency requirements?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="text"
              className="form-control "
              id="livedate"
              name="fullname"
              value={latencyReq}
              onChange={(e) => {
                setLatencyReq(e.target.value);
              }}
            />
            {errors?.latencyReq && (
              <p className="text-red">This field cannot be empty</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Where will the servers be hosted?
              <span className="color-red">*</span>
            </MDTypography>

            <TextField
              type="text"
              className="form-control "
              id="livedate"
              name="fullname"
              value={serversHost}
              onChange={(e) => {
                setServersHost(e.target.value);
              }}
            />
            {errors?.serversHost && (
              <p className="text-red">This field cannot be empty</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Which system prospect would be using to connect to API?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="text"
              className="form-control "
              id="livedate"
              name="fullname"
              placeholder="(Third-Party, Proprietary System, Black Box, Algo, ETC.)"
              value={systemProspect}
              onChange={(e) => {
                setSystemProspect(e.target.value);
              }}
            />
            {errors?.systemProspect && (
              <p className="text-red">This field cannot be empty</p>
            )}
            <br />
          </Grid>

          <Grid item xs={12} lg={4}>
            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Where will the clearing be done?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="text"
              className="form-control "
              id="livedate"
              name="fullname"
              placeholder="(Velocity, Introduced to Goldman, Pershing)"
              value={clearingDone}
              onChange={(e) => {
                setClearingDone(e.target.value);
              }}
            />
            {errors?.clearingDone && (
              <p className="text-red">This field cannot be empty</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Count of messages expected per day?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              min={0}
              type="number"
              className="form-control "
              id="livedate"
              name="fullname"
              value={msgPerDay}
              onChange={(e) => {
                setMsgPerDay(e.target.value);
                setMsgPerDayNotNeg(e.target.value);
              }}
            />
            {errors?.msgPerDay && (
              <p className="text-red">This field cannot be empty</p>
            )}
            {errors?.msgPerDayNotNeg && (
              <p className="text-red">Please add non negative number</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Where will this business be routed?
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="text"
              className="form-control "
              id="livedate"
              name="fullname"
              value={businessRoute}
              onChange={(e) => {
                setBusinessRoute(e.target.value);
              }}
            />
            {errors?.businessRoute && (
              <p className="text-red">This field cannot be empty</p>
            )}

            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              How many messages per second and peak number
              <span className="color-red">*</span>
            </MDTypography>
            <TextField
              type="number"
              className="form-control "
              id="livedate"
              name="fullname"
              value={msgPerSecPeak}
              onChange={(e) => {
                setMsgPerSecPeak(e.target.value);
                setMsgPerSecPeakNotNeg(e.target.value);
              }}
            />
            {errors?.msgPerSecPeak && (
              <p className="text-red">This field cannot be empty</p>
            )}
            {errors?.msgPerSecPeakNotNeg && (
              <p className="text-red">Please add non negative number</p>
            )}
            <MDTypography
              variant="p"
              fontWeight="regular"
              fontFamily="inherit"
              lineHeight={3}
              sx={{ fontSize: "14px" }}
            >
              Risk check to be done through Succession?
              <span className="color-red">*</span>
            </MDTypography>
            <br />
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  control={<Radio />}
                  label="Yes"
                  type="radio"
                  name="riskcheck"
                  value="false"
                  onChange={(e) => {
                    setSuccession(e.target.value);
                  }}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="No"
                  type="radio"
                  name="riskcheck"
                  value="true"
                  onChange={(e) => {
                    setSuccession(e.target.value);
                  }}
                />
              </RadioGroup>
              {errors?.succession && (
                <p className="text-red">Please select an option</p>
              )}
            </FormControl>
          </Grid>
          <Grid item lg={8}>
            {succession == "true" && (
              <TextField
                type="text"
                className="form-control "
                id="livedate"
                name="fullname"
                placeholder="If No, please specify the alternative"
                value={riskcheck}
                onChange={(e) => {
                  setRiskcheck(e.target.value);
                }}
              />
            )}
            <MDBox mt={2} mb={1}>
              {showErrorMessage != "" && (
                <p className="text-red">{showErrorMessage}</p>
              )}
              <MDButton
                variant="gradient"
                color="success"
                sx={{ minWidth: 200 }}
                onClick={() => {
                  setText("Trading API");
                  handleSubmit("Trading API");
                }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Send Request"
                )}
              </MDButton>
            </MDBox>
          </Grid>
        </>
      );
    } else {
      return (
        <Grid item xs={12} lg={4} fullwidth>
          <TextareaAutosize
            className={darkMode ? "qoute-tarea" : "qoute-tarea white"}
            color="inherit"
            aria-label="minimum height"
            minRows={3}
            placeholder="Your Message"
            value={text}
            onChange={(event) => {
              setText(event.target.value);
            }}
          />
          {errors?.text && (
            <p className="text-red">Description cannot be empty.</p>
          )}
          <MDBox mt={2} mb={1}>
            {showErrorMessage != "" && (
              <p className="text-red">{showErrorMessage}</p>
            )}
            <MDButton
              variant="gradient"
              color="success"
              sx={{ minWidth: 200 }}
              onClick={() => handleSubmit(text)}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Send Request"
              )}
            </MDButton>
          </MDBox>
        </Grid>
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={5} className={darkMode ? "dark-pa" : "light-pa"}>
        <Card className="pattren-gp gpa">
          <CardContent>
            <MDBox>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      fontFamily="inherit"
                      lineHeight={3}
                    >
                      What are you looking for?{" "}
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth>
                      <InputLabel>Select API</InputLabel>
                      <MDTypography
                        variant="p"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={3}
                        sx={{ fontSize: "14px" }}
                      >
                        Which API are you interested in?
                        <span className="color-red">*</span>
                      </MDTypography>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={productId}
                        onChange={(event) => setProductId(event.target.value)}
                        sx={{ padding: 1, marginBottom: 0 }}
                      >
                        {userData?.apirequestaccessItem?.map((item) => {
                          if (item.status === "A" && !item?.production) {
                            return (
                              <MenuItem
                                key={item.apiid}
                                value={item.apiid}
                                onClick={() => {
                                  setApiID(item.apiid);
                                  setRequired(item.apiQuestionnaireData);
                                  console.log(required);
                                }}
                              >
                                {item.apiName}
                              </MenuItem>
                            );
                          }
                        })}
                        {userData?.apirequestaccessItem?.filter(
                          (item) => !item?.production
                        ).length <= 0 && (
                          <MenuItem value={null}>
                            No Products available
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    {errors?.product && (
                      <p className="text-red">API must be selected.</p>
                    )}
                  </Grid>
                  <Grid item xs={10} lg={8}></Grid>
                  {renderContent()}
                </Grid>
              </Box>
            </MDBox>
          </CardContent>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GetQuote;
